export const SelectedOptionGroupKeyring = {
  makeSize(fitted_size: { width: number; height: number }) {
    return {
      width: fitted_size.width,
      height: fitted_size.height,
    };
  },
};
